import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {getProductById} from "~/domainModels/ottokart/products";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/products/$productId/")({
    loader: async ({context, params}) => {
        const {productId: productIdRaw} = params;
        if (productIdRaw === "new") {
            return {
                product: null
            };
        }
        else {
             const productIdResult = uuidZodValidator.safeParse(productIdRaw);
             if (!productIdResult.success) {
                throw new Error("Invalid product ID");
            }
            const productId = productIdResult.data;
            const productResult = await getProductById({
                intellsysBaseUrl: context.intellsysBaseUrl,
                workspaceId: context.workspace.id,
                accessToken: context.authenticationStatus.accessToken,
                productId: productId,
            });
            if (productResult.success !== true) {
                throw productResult.error;
            }
            const product = productResult.data;
            return {
                product: product
            };
        }
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
